const FORMAT_ALIASES: Readonly<Record<string, string>> = { stp: 'step', jpeg: 'jpg' };

/** One name per format, as the user knows it: JPEG is JPG, STP is STEP. */
export const displayFormats = (extensions: readonly string[]): string[] => [
  ...new Set(extensions.map((ext) => (FORMAT_ALIASES[ext.toLowerCase()] ?? ext).toUpperCase())),
];
